import { getPictureUrl } from 'shared_DEPRECATED/utils';

import { ParticipantsTableUserInfo } from 'features/participants/config/types';
import { SessionSidebarFieldset } from 'features/sessions/components';
import { UserInfo } from 'features/user/components';

import { useSidebarContext } from 'shared/components/Sidebar/context';

export const NextSessionUserInfo = () => {
  const { userInfo }: { userInfo: ParticipantsTableUserInfo } =
    useSidebarContext();

  return (
    <SessionSidebarFieldset>
      <UserInfo
        name={userInfo.fullName || userInfo.email}
        pictureUrl={getPictureUrl(userInfo.picture)}
      />
    </SessionSidebarFieldset>
  );
};
